import {
  createStore, applyMiddleware, compose, combineReducers,
} from 'redux';
// import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import ScaffoldingReducer from './reducers/scaffolding';
import SitesReducer from './reducers/sites';
import SuppliersReducer from './reducers/suppliers';
import DashUsersReducer from './reducers/dashusers';
import CommonReducer from './reducers/common';

// We dont need a logger but uncomment below code if you need it anyway
// instead use - https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd

// const rLogger = createLogger({
//   // removing unwanted logs in logger
//   predicate: (getState, action) =>
//     ![undefined].includes(action.type),
// });

const rootReducer = combineReducers({
  scaffoldingReducer: ScaffoldingReducer,
  sites: SitesReducer,
  suppliers: SuppliersReducer,
  dashusers: DashUsersReducer,
  common: CommonReducer,
});

const middleware = applyMiddleware(thunk);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export default createStore(rootReducer, composeEnhancers(middleware));
